import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { ExperienceUser } from './experience-user.model';

export class ExperienceUserStateModel extends EntityStateModel<ExperienceUser> {}
